import React, {useEffect} from 'react';
import LazyLoad from 'react-lazyload';

function AdSenseAdWrapper(props) {
  //mount edilince pushu çağır
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch(err) {
      console.log("Adsense push error", err);
    }
  }, []);

  return props.children
}

export default function LazyLoaded(props) {
  return <LazyLoad className={props.className} 
      offset={200} 
    placeholder={props.placeholder}
  >
    <AdSenseAdWrapper props>
      {props.children}
    </AdSenseAdWrapper>
  </LazyLoad>
}
